import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { useSelector } from 'react-redux';
import { RootState } from '..';
import { vesselVoyageReportingList } from 'VesselMaster/vesselMaster.hooks';
import { CardBody } from 'reactstrap';
import ToolTip from 'Components/ToolTip';
import ViewReport from '../Media/view.png'
import ViewReportModal from '../Components/ViewReportModal';

const CompletedReports = () => {
    const { VoyageID, VesselID } = useSelector((state: RootState) => state.Reporting);
    const [viewReport, setViewReport] = useState(false);
    const [reportId, setReportId] = useState(0);

    /**
    * fucntion returns Vessel Voyage Reporting information 
    * @param number VesselID
    * @param number VoyageID
    * @returns mix
    */
    const { data: reports, isFetching: reportsFetching, isError: reportsError } = useQuery(
        [queryKeyes.vessel.vesselVoyageReporting.key, VesselID, VoyageID],
        async () => { return await vesselVoyageReportingList(VesselID, VoyageID) },
        { staleTime: Infinity })

    const handleViewChanges = (id: number) => {
        setViewReport(true);
        setReportId(id);
    }

    return (
        <CardBody>
            <div className="table-responsive" id='owner_table'>
                {reportsFetching && (
                    (<div
                        className="alert-border-left mb-0 alert alert-info alert-dismissible fade show"
                        role="alert">
                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                        <strong>Loading</strong> - Vessel reporting information</div>)
                )}
                {reportsError && (
                    <div className="alert-border-left alert alert-danger alert-dismissible fade show" role="alert">
                        <button type="button" className="btn-close" aria-label="Close"></button>
                        <i className="mdi mdi-block-helper me-3 align-middle"></i>
                        <strong>Error</strong> while fetching Vessel reporting information!!</div>
                )}
                {((!reportsFetching && !reportsError) && reports.length > 0) &&
                    <table className="table mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Sr. No.</th>
                                <th>Vessel report name</th>
                                <th>Vessel report type</th>
                                <th>Reporting time</th>
                                <th>Actions</th>

                            </tr>
                        </thead>
                        <tbody>
                            {reports.length > 0 && reports?.sort((a: any, b: any) => b.id - a.id).filter((item: any) => item.vessel_reporting_status === 'sent').map((report: any, index: number) => (
                                <>
                                    <tr key={report.id}>
                                        <td>{index + 1}</td>
                                        <td>{report.reporting_event_name}</td>
                                        <td>{report.reporting_type}</td>
                                        <td>{report.reporting_time_utc.slice(0, 10)} {report.reporting_time_utc.slice(11, 16)}</td>
                                        <ToolTip target='view_details' message='View details' />
                                        <td>
                                            <img
                                                alt="View Report"
                                                className='mr-2 align-middle pointer'
                                                src={ViewReport}
                                                height="25"
                                                id='view_details'
                                                onClick={() => {
                                                    handleViewChanges(report.id)
                                                }}
                                            />
                                        </td>
                                        {reportId === report.id && <ViewReportModal state={viewReport} vesselId={VesselID} reportId={reportId} modalId={`${VesselID}${reportId}`} />}
                                    </tr>
                                </>
                            ))
                            }
                        </tbody>
                    </table>
                }
            </div>
        </CardBody>
    )
}

export default CompletedReports
